import { render, staticRenderFns } from "./TopicReference.vue?vue&type=template&id=631274de&scoped=true"
import script from "./TopicReference.vue?vue&type=script&lang=js"
export * from "./TopicReference.vue?vue&type=script&lang=js"
import style0 from "./TopicReference.vue?vue&type=style&index=0&id=631274de&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631274de",
  null
  
)

export default component.exports